import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-hidden-wrapper',
  template: '',
})
export class HiddenWrapperComponent extends FieldWrapper {}
